// Wrapper around a full page reload so that specs can observe it: jsdom does
// not implement navigation and does not allow stubbing window.location.
export const reloadPage = (): void => {
  window.location.reload()
}

export const navigateTo = (path: string): void => {
  window.location.assign(path)
}
